import ApiConfig from '../config/api-config';
import { TOKEN_KEY, REFRESH_TOKEN_KEY, URL_RETURN_KEY, CSRF_TOKEN_KEY } from '../config/common';
import Cookies from 'js-cookie';
import { DecodeToken } from './jwt-token-helper';

export const APIUrlDefault = ApiConfig.apiUrl;
export const MediaUrl = ApiConfig.mediaUrl;
export const DOMAIN = ApiConfig.domain;
//--- Cookies

const dateExpires = new Date();
dateExpires.setTime(dateExpires.getTime() + 720 * 60 * 60 * 1000);

export const setCookiesUser = (res: any) => {
  const { token, refreshToken, returnUrl } = res
  const expireTime = new Date();
  expireTime.setTime(expireTime.getTime() + 24 * 60 * 60 * 1000);

  const options = {
    path: "/",
    expires: expireTime,
  };
  Cookies.set(TOKEN_KEY, token, options);
  Cookies.set(REFRESH_TOKEN_KEY, refreshToken, options);
  Cookies.set(URL_RETURN_KEY, returnUrl, options);
};

export function getCookies(name: string) {
  return Cookies.get(name);
}

export function removeCookies(
  name: string,
  options = { path: "/" }
) {
  Cookies.remove(name, options);
}

export const setLockScreen = (
  isLockScreen: boolean,
  options = { path: "/" }
) => {
  Cookies.set("isLockScreen", `${isLockScreen}`, options);
};

export const setIsShowDialogConfirmRefresh = (
  isShow: boolean,
  options = { path: "/" }
) => {
  Cookies.set("isShowDialog", `${isShow}`, options);
};

export function getUserInfo() {
  const userInfoToken = getCookies(TOKEN_KEY);
  if (!userInfoToken) return null;
  try {
    const userInfo = DecodeToken(userInfoToken);
    return userInfo;
  } catch (error) {
    console.error("Invalid Base64 token:", error);
    return null;
  }
}

export const setCookiesCsrfToken = (token: string) => {
  const expireTime = new Date();
  expireTime.setTime(expireTime.getTime() + 24 * 60 * 60 * 1000);
  Cookies.set(CSRF_TOKEN_KEY, token, {
    path: "/",
    expires: expireTime,
    secure: true,
    sameSite: "strict"
  });
};

export const listGender = [
  {
    label: 'Nam',
    value: true,
  },
  {
    label: 'Nữ',
    value: false,
  }
]

// --- Map
export const listBaseMap = [
  {
    label: 'Google Map',
    value: 'https://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}&s=Ga',
  },
  {
    label: 'Vệ tinh',
    value: 'https://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga',
  },
]